import React from 'react'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import type { DialogProps } from '@material-ui/core/Dialog'
import { TranslationDictionary } from '@plandi/common'

import { useConfirmModalStyles } from './confirm-modal.styles'

export type ConfirmModalProps = {
  title?: string
  isOpen: boolean
  onClose: (e: React.SyntheticEvent) => void
  onOk: (event: React.MouseEvent<unknown, MouseEvent>) => void
  DialogProps?: Partial<DialogProps>
  translate?: TranslationDictionary['data']
}

export const ConfirmModal: React.FC<ConfirmModalProps> = (props) => {
  const classes = useConfirmModalStyles()

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      maxWidth="xs"
      fullWidth
      {...props.DialogProps}
    >
      <DialogActions>
        <IconButton
          onClick={props.onClose}
          className={classes.closeButton}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogActions>
      <DialogContent style={{ padding: 24 }}>
        <Typography variant="h5">{props.title}</Typography>
      </DialogContent>
      <DialogActions>
        <div className={classes.buttons}>
          <Button onClick={props.onClose} className={classes.btn}>
            {props.translate?.shop['projects-page']?.cancel}
          </Button>
          <Button
            onClick={props.onOk}
            variant="contained"
            color="secondary"
            className={classes.btn}
          >
            {props.translate?.confirm}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}
